import { addDomainAndTokenToAnalyticsURL, IHttpResponse, restGet } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { IMenuList } from '~/src/dash/types/menuList';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

export async function getContentChannelFilterOptions(
  session: ISessionState,
  user: IUserState,
): Promise<Record<string, IMenuList>> {
  const reqURL =
    addDomainAndTokenToAnalyticsURL('/content_channel_filter_options') +
    `&publisher_id=${session.publisher.ID}`;

  return await restGet<any>(reqURL, {})
    .then((val: IHttpResponse<any>) => {
      const contentChannels = val.parsedBody?.content_channels;
      return {
        content_channels: generateMenuListFromStrings(user, contentChannels, 'content_channel'),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        content_channels: {},
      };
    });
}

export async function getContentNetworkFilterOptions(
  session: ISessionState,
  user: IUserState,
): Promise<Record<string, IMenuList>> {
  const reqURL =
    addDomainAndTokenToAnalyticsURL('/content_network_filter_options') +
    `&publisher_id=${session.publisher.ID}`;

  return await restGet<any>(reqURL, {})
    .then((val: IHttpResponse<any>) => {
      const contentNetworks = val.parsedBody?.content_networks;
      return {
        content_networks: generateMenuListFromStrings(user, contentNetworks, 'content_network'),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        content_networks: {},
      };
    });
}

export async function getOrigContentChannelFilterOptions(
  session: ISessionState,
  user: IUserState,
): Promise<Record<string, IMenuList>> {
  const reqURL =
    addDomainAndTokenToAnalyticsURL('/orig_content_channel_filter_options') +
    `&publisher_id=${session.publisher.ID}`;

  return await restGet<any>(reqURL, {})
    .then((val: IHttpResponse<any>) => {
      const origContentChannels = val.parsedBody?.orig_content_channels;
      return {
        orig_content_channels: generateMenuListFromStrings(
          user,
          origContentChannels,
          'orig_content_channel',
        ),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        orig_content_channels: {},
      };
    });
}

export async function getOrigContentNetworkFilterOptions(
  session: ISessionState,
  user: IUserState,
): Promise<Record<string, IMenuList>> {
  const reqURL =
    addDomainAndTokenToAnalyticsURL('/orig_content_network_filter_options') +
    `&publisher_id=${session.publisher.ID}`;

  return await restGet<any>(reqURL, {})
    .then((val: IHttpResponse<any>) => {
      const origContentNetworks = val.parsedBody?.orig_content_networks;
      return {
        orig_content_networks: generateMenuListFromStrings(
          user,
          origContentNetworks,
          'orig_content_network',
        ),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        orig_content_networks: {},
      };
    });
}

const generateMenuListFromStrings = (user: IUserState, strs: string[], obfuscatePrefix: string) => {
  const menuList: IMenuList = {};

  const shouldObfuscate = checkUserInfoMasked(user.user);
  strs.forEach((str: string, idx: number) => {
    const itemName = shouldObfuscate ? `demo_${obfuscatePrefix}_${idx}` : str;

    menuList[itemName] = {
      ID: itemName,
      selected: false,
      title: itemName,
    };
  });

  return menuList;
};
